import React from 'react';
import { render } from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import configureStore from './redux/configureStore';
import * as serviceWorker from './serviceWorker';
import "bootstrap/dist/js/bootstrap.min.js";
export const { store, persistor } = configureStore();

// Stripe.js is loaded lazily by the pages that actually take payment
// (see pages/Checkout, pages/OrderEdit) instead of wrapping the whole app
// here. StripeProvider initializes Stripe.js as soon as it mounts, and
// Stripe.js creates full-viewport fraud-detection iframes as a side effect -
// mounting it globally meant those iframes existed on every page (e.g. the
// sign-in modal), and could end up covering the page and blocking clicks
// after unrelated actions like a failed sign-in.

render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </ReduxProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
